import Loading from 'Components/Atoms/Loading/Loading';

export default function AppSkeleton() {
    return (
        <div className="min-h-dvh">
            <div className="fixed bg-white top-0 left-0 bottom-0 w-(--sidebar-width) ring ring-black/5 hidden md:block" />

            <div className="h-full md:pl-(--sidebar-width)">
                <header className="h-15 bg-white  shadow-2xs md:shadow-none" />
                <div className="flex items-center justify-center py-16">
                    <Loading />
                </div>
            </div>
        </div>
    );
}
